<template>
  <div class="itEnvRootBox" ref="itEnvRootBox">
    <it-loading ref="itLoading" v-show="platformType && platformType!==platformTypeConstant.codeBlockOS"></it-loading>
    <div class="itEnvOptionBtBox">
      <div class="selectCodeType" v-show="platformType===platformTypeConstant.codeBlockOS">
        <span style="color: rgba(225, 222, 222, 0.6);">编译语言： </span>
        <el-select ref="mSelect" v-model="language" :disabled="disabled">
          <el-option v-for="(item,index) in languageOptions" :key="index" :value="item.value" :label="item.label"
                     ref="mOption"></el-option>
        </el-select>
      </div>
      <div v-show="showToolsBox" class="itEnvOptionBt">
        <i :class="showTools?'el-icon-setting':'el-icon-s-tools'" @click="showTools = !showTools"></i>
        <transition name="slide-fade">
          <ul v-show="showTools" @click="showTools = false">
            <el-tooltip v-for="(item,index) in getBts()"
                        :key="index"
                        :content="item.content()"
                        v-show="item.show() && !hiddenBts.includes(index)"
                        placement="left" effect="light">
              <li :class="item.css()" @click="item.click()" :style="item.styles()"></li>
            </el-tooltip>
            <slot name="tools" class="itEnvOptionBt"></slot>
          </ul>
        </transition>
      </div>
    </div>
    <div class="itEnvContentBox">
      <code_compiler
        :style="getStyles(platformType === platformTypeConstant.codeBlockOS)"
        class="itEnvCss"
        v-model="codeValue"
        :refresh="refresh"
        :isHas="isHas"
        :readOnly="readOnly"
        :openRight="openRight"
        :readPage="readPage"
        :image_text="imageText"
        :task="task"
        :questionAnswer="questionAnswer"
        :questionId="questionId"
        :consoleBoxStyle="consoleBoxStyle"
        :language="language"
        @getOutput="output"
      ></code_compiler>
      <iframe
        :style="getStyles(platformType !== platformTypeConstant.codeBlockOS)"
        width="100%" height="100%" ref="iframeOS" :src="iframeUrl" class="itEnvCss"></iframe>
      <div ref="itScreenshot" class="itScreenshot" v-if="screenshotData.data">
        <img :src="screenshotData.data"
             :style="platformType === platformTypeConstant.jupyterNoteBook ? 'width:100%;height:100%' : null">
      </div>
    </div>
  </div>
</template>

<script>
import Code_compiler from "@/views/component/code_compiler.vue";
import {isLinuxLabOS, sendClipboardContent} from "@/utils/utils";
import ItLoading from "@/views/szrt_revision/teachingDetail/list/classroom/itLoading";

export default {
  name: "itEnv",
  components: {ItLoading, Code_compiler},
  props: {
    value: {
      type: String,
      default: "",
    },
    codeRefresh: {
      type: [Boolean, String, Number],
      default: 1,
    },
    isHas: {
      type: Boolean,
      default: true,
    },
    task: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    openRight: {
      type: Boolean,
      default: false,
    },
    readPage: {
      type: Boolean,
      default: false,
    },
    imageText: {
      type: Boolean,
      default: false,
    },
    questionAnswer: {
      type: String,
      default: '',
    },
    questionId: {//试题ID
      type: [String, Number],
      default: '',
    },
    consoleBoxStyle: {
      type: Object,
      default: () => ({
        minHeight: '200px'
      }),
    },
    platformType: {
      type: String,
      default: ''
    },
    iframeSrc: {
      type: String,
      default: ''
    },
    showToolsBox: {//显示工具条，重置，重启
      type: Boolean,
      default: false,
    },
    hiddenBts: {
      type: Array,
      default: () => ([])//隐藏的按钮，数字下标组成的数组,可以隐藏重启、重置等操作按钮
    },
    disabled: {
      type: Boolean,
      default: false,//是否禁止操作,不会禁止重启、重置等操作按钮
    },
    showLoading: {
      type: Boolean,
      default: true,//默认显示Loading
    },
    languageOptions: {
      type: Array,
      default: () => [
        {label: "python", value: "python"},
        {label: "java", value: "java"},
        {label: "c", value: "c"},
        {label: "c++", value: "c++"},
        {label: "c#", value: "c#"}
      ]
    },
    codeBlockLanguage: {
      type: String,
      default: 'python'
    }
  },
  computed: {
    platformTypeConstant() {
      return {
        codeBlockOS: 'codeBlockOS',
        jupyterNoteBook: 'jupyterNoteBook',
        linuxLabOS: 'linuxLabOS',
        jupyterTerminals: 'jupyterTerminals'
      }
    },
    getStyles() {
      return function (condition) {
        return {
          transform: condition ? 'translateX(0%)' : 'translateX(-110%)',
          opacity: condition ? '1' : '0',
          pointerEvents: this.disabled ? 'none' : 'auto'
        }
      }
    },
    getBts() {
      return function () {
        return [
          {
            content: () => this.timeout ? `请${this.timeout}秒后再重置` : '重置数据',
            styles: () => ({cursor: this.timeout ? 'not-allowed' : 'pointer'}),
            css: () => 'el-icon-refresh',
            click: () => this.reset(),
            show: () => true
          },
          {
            content: () => this.timeout ? `请${this.timeout}秒后再重启` : '重启环境',
            styles: () => ({cursor: this.timeout ? 'not-allowed' : 'pointer'}),
            css: () => 'el-icon-video-play',
            click: () => this.restart(),
            show: () => (this.platformType !== this.platformTypeConstant.codeBlockOS)
          }
        ]
      }
    }
  },
  watch: {
    codeRefresh: {
      handler(newVal) {
        this.refresh = Number(newVal)
      },
      immediate: true
    },
    value: {//代码块使用
      handler(newVal) {
        this.codeValue = newVal
      },
      immediate: true
    },
    codeValue: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
    },
    iframeSrc: {
      handler(newVal) {
        this.iframeSrcChange(newVal)
      },
      immediate: true
    },
    iframeLoading: {
      handler(newVal) {
        this.itEnvLoading(newVal)
      }
    },
    codeBlockLanguage: {
      handler(newVal) {
        this.language = newVal
      },
      immediate: true
    }
  },

  data() {
    return {
      language: this.codeBlockLanguage,
      showTools: false,
      iframeUrl: this.iframeSrc,
      refresh: Number(this.codeRefresh),
      oldCodeValue: '',
      codeValue: '',
      timeout: 0,
      timeoutId: 0,
      iframeLoading: false,
      sendClipboardId: 0,
      screenshotData: {
        source: null,
        data: null,
      },
      isReady: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        window.addEventListener('message', this.getWindowMessage)
        this.oldCodeValue = String(this.value == null ? '' : this.value)
      }, 1000)
    })
    window.addEventListener('beforeunload', () => this.resetData());
    // const div = this.$refs.mSelect.$el.querySelector('.el-select-dropdown')
    // div.style.backgroundColor = '#2B3C4E'
    // div.style.border = '1px solid #3e556e';
  },
  beforeDestroy() {
    // console.log('itEnv beforeDestroy')
    this.resetData()
  },
  methods: {
    resetData() {
      window.removeEventListener('message', this.getWindowMessage)
      this.iframeUrl = ''
      this.timeout = 0
      this.iframeLoading = false
      clearInterval(this.timeoutId)
      clearInterval(this.sendClipboardId)
      clearInterval(this.getIframeScreenshot.intervalId)
    },
    getWindowMessage(message) {
      // console.log('itEnv message',message)
      if (!message || !message.data || !this.iframeSrc) return;
      if (message.data.form === 'score') {// 获取从编译器评分后返回的数据
        let result = null
        let success = false
        if (message.data.data) {
          let res = JSON.parse(message.data.data)
          success = String(res.code) === '0'
          result = res.result
        }
        this.$emit('itEnvScore', result, success)
        console.log('获得评分', message.data.form, result)
        this.stopAnimation()
      } else if (message.data.form === 'ready') {
        console.log('环境初始化成功', message.data.form)
        this.$emit('itEnvReady')//环境准备就绪
        this.initRectSize()
        this.startSendClipboardContent()
      } else if (message.data.form === 'reset') {
        this.$emit('itEnvReady')//环境准备就绪
        this.initRectSize()
        this.startSendClipboardContent()
        console.log('环境重置成功', message.data.form)
      } else if (message.data.form === 'screenshot' && this.isLinuxOS()) {
        if (message.data) {
          this.screenshotData.source = message.data.source
          this.screenshotData.data = message.data.data
        }
        console.log('获取截图成功', this.screenshotData)
      }
      this.$emit('itEnvMessage', message)//环境准备就绪
    },
    /**
     * 启动复制粘贴功能
     */
    async startSendClipboardContent() {
      console.log('启动复制发送功能', this.platformType)
      if (this.platformType) {
        this.nextAnimation()
        this.isReady = true
        if (isLinuxLabOS(this.platformType)) {
          clearInterval(this.sendClipboardId)
          this.sendClipboardId = await sendClipboardContent(this.$refs.iframeOS)
        }
      }
    },
    initRectSize() {
      const offsetWidth = this.$refs.itEnvRootBox.offsetWidth
      const offsetHeight = this.$refs.itEnvRootBox.offsetHeight
      console.log('initRectSize=>', offsetWidth, offsetHeight)
      this.sendIframeOSMessage({gxzl: true, type: `screensize=${offsetWidth}x${offsetHeight}`})
    },
    /**
     * 输出
     */
    output(data) {
      this.$emit('itEnvOutput', data)
    },
    /**
     * 重置
     */
    reset() {
      if (this.platformType === this.platformTypeConstant.codeBlockOS) {
        this.codeValue = this.oldCodeValue;
        ++this.refresh
      } else {
        if (this.timeout > 0) return;
        console.log('reset', '开始访问:', this.iframeUrl)
        this.sendIframeOSMessage({gxzl: true, type: 'reset'})
        this.playAnimation()
        this.setMTimeout()
      }
    },
    /**
     * 重启
     */
    restart() {
      console.log('restart', this.timeout, this.platformType)
      if (this.isLinuxOS()) {
        if (this.timeout > 0) return;
        this.playAnimation()
        let r1 = '&restart=1'
        this.iframeUrl = this.iframeSrc.replace(r1, '')
        this.$nextTick(() => {
          this.iframeUrl += r1
          console.log('restart', '开始访问:', this.iframeUrl)
        })
        this.setMTimeout()
      }
    },
    setMTimeout() {
      this.timeout = 30
      this.timeoutId = setInterval(() => {
        if (this.timeout > 0) {
          --this.timeout
        } else {
          this.clearMTimeoutInterval()
        }
      }, 1000)
    },
    /**
     * 发送给系统消息
     * @param params
     * @returns {ElMessageComponent}
     */
    sendIframeOSMessage(params = {}) {
      // if (this.iframeLoading) return this.$message.warning('加载中，请稍等！');
      // console.log('sendIframeOSMessage', params)
      this.$refs.iframeOS.contentWindow.postMessage(params, this.iframeUrl);
    },
    /**
     * 执行评分
     * @param params
     * @returns {ElMessageComponent}
     */
    exeScore(params) {
      if (this.iframeLoading) return this.$messageWarning('工具未初始化成功，请稍等')
      this.sendIframeOSMessage({gxzl: true, type: 'score', params})
    },
    clearMTimeoutInterval() {
      clearInterval(this.timeoutId)
      this.timeout = 0
    },
    playAnimation() {
      this.iframeLoading = true
      this.showLoading && this.$refs.itLoading.playAnimation()
    },
    nextAnimation() {
      this.iframeLoading = false
      this.showLoading && this.$refs.itLoading.nextAnimation()
    },
    stopAnimation() {
      this.iframeLoading = false
      this.showLoading && this.$refs.itLoading.stopAnimation()
    },
    itEnvLoading(newVal) {
      this.$emit('itEnvLoading', newVal)
    },
    iframeSrcChange(newVal) {
      this.iframeUrl = newVal
      this.isReady = false
      // console.log('iframeUrl', newVal, Boolean(newVal))
      if (newVal && newVal.replace(/\s+/g, '')) {
        this.$nextTick(() => {
          if (this.isLinuxOS()) {
            this.playAnimation()
          }
        })
      }
    },
    /**
     * 获得Iframe的截图
     */
    async getIframeScreenshot() {
      return new Promise(resolve => {
        this.resetScreenshotPage()
        clearInterval(this.getIframeScreenshot.intervalId)
        let count = 0
        const ready = (this.isReady && !this.iframeLoading)
        if ((ready && this.isLinuxOS())) {
          this.sendIframeOSMessage({gxzl: true, type: 'screenshot'})
          this.getIframeScreenshot.intervalId = setInterval(() => {
            ++count
            if (this.screenshotData.data || count > 5) {//3秒拿不到数据也结束
              resolve(this.resetScreenshotPage)
              clearInterval(this.getIframeScreenshot.intervalId)
            }
          }, 500)
        } else {
          resolve(this.resetScreenshotPage)
        }
      })
    },
    /**
     *重置截图位置数据
     */
    resetScreenshotPage() {
      this.screenshotData.source = null
      this.screenshotData.data = null
    },
    isLinuxOS() {
      return this.platformType && this.platformType !== this.platformTypeConstant.codeBlockOS
    }
  }
}
</script>

<style scoped lang="scss">
.itEnvRootBox {
  overflow: hidden;
  height: 100%;
  width: 100%;
}


.itEnvCss {
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;
}

.itEnvContentBox {
  width: 100%;
  height: 100%;
  position: relative;

  .itScreenshot {
    width: calc(100% - 20px);
    height: 100%;
    position: absolute;
    z-index: 2;
    background: rgb(40, 40, 40);
    display: flex;

    & > img {
      margin: auto;
      outline: none;
      cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAYAAACZm7S3AAAAAXNSR0IArs4c6QAAArZJREFUOE+NlEtIG1EUhv9JDCGJgyJ0LXGhC0cDImisDbiyEimCOMusis4qBYdbxmA3hdpFqREqJI1SWqV5aG0gtQQK6mxCECyi1I2NINSF0DYVtY3mNeXKZEhIH97NwHC/75wz55xhABjS6fSzhoaG+wDOARRxzcMAsCiKcp5MJhd7enoIgK/XFVCYVRTl9PDwMLu/vx/u7++ngm/XEWhwW1sb4vF4bmdn58Xg4OAkgPT/BBpcV1eH5uZmxGKx3Pb2ts/pdD4E8ONfAg02m82ora0Fx3GIRCI5WZaf8jz/BMDJ3wQaXFNTA5ZlrwTt7e1YWFjIra+vP+Z53gvg9E8CDWYYBhaL5Qqmko6ODvj9/tzq6uqky+V6rgqU8i5WwAaDQYtOBV1dXZiens6Fw2FREIRXAM4AaIIKmFpLkUsl2O12TE1NZUOh0D1BEF6rg3QlqIKNRmNFdCpzOBzweDzZQCAgEELelARVsE6n06KXsqDP3t5eEEIufT7fXUmSogB+VcE0HZPJhPr6eiQSCcVqtdI72slkMmd+v58fHx9fq4IbGxvhdDoRDAYxNjaGkZGRo87OzkfqzOcBZAEcAfhcATc1NUGW5TzLsgzHcXq9Xo+tra28x+OR5ufnI2q7aBZUcqHBLS0t2NjYyEej0TWbzXZDlmWb1+vVE0KUvr6+T93d3XcAfAFQKNWgwcfHx/lgMPheFMUAIUQ3MTHxluM4A23Z5uZmfnR01LW0tBQD8LMCLhQKJzMzMyFRFBcBfARwube39255efnW7Oysjo5qKpVadLvdkrquWp/N8XjcPTAwINOPoG4S5ubmbg4PD3/Y3d1lWltblaGhoQeJROIlgO+lKaNp6+nfRK0lU7YAJkmSbheLRfvKykrq4OAgqcovytMu72P54NP3RjqxqpDWStuk3fkNeQFBNZ4diZcAAAAASUVORK5CYII=) 2 2, default;
      width: 1280px;
      height: 1024px;
    }
  }
}

.itEnvOptionBtBox {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;

  .selectCodeType {
    margin-right: 10px;
    height: 30px;
    display: flex;
    align-items: center;

    /deep/ input.el-input__inner {
      width: 120px;
      height: 26px !important;
      border-radius: 0 !important;
      background-color: #2B3C4E !important;
      border: 1px solid #3e556e;
      color: rgba(225, 222, 222, 0.6);
    }


    /deep/ .el-input__icon {
      display: flex;
      align-items: center;
    }
  }

  .itEnvOptionBt {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & > i {
      padding: 5px;
      font-size: 1.2em;
      background: #DCDAD5;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & > i:hover {
      background: white;
    }

    & > ul {
      top: 29px;
      position: absolute;
      z-index: -1;
      list-style: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #bbbaba;

      /deep/ li {
        padding: 5px;
        font-size: 1.2em;
        margin-top: 1px;
        background: #DCDAD5;
        cursor: pointer;

        :hover {
          background: white;
        }
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all .5s;
  transform: translateY(0%);
}

.slide-fade-leave-active {
  transition: all .5s;
  transform: translateY(-100%);
}

.slide-fade-enter {
  transform: translateY(-100%);
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/itEnv.vue